import { render, staticRenderFns } from "./AccessLogs.vue?vue&type=template&id=215e8175&scoped=true&"
import script from "./AccessLogs.vue?vue&type=script&lang=js&"
export * from "./AccessLogs.vue?vue&type=script&lang=js&"
import style0 from "./AccessLogs.vue?vue&type=style&index=0&id=215e8175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215e8175",
  null
  
)

export default component.exports